import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { availabilityShape, bibShape, childrenShape } from '@bibliocommons/bc-prop-types';
import AvailabilityStatus from '@bibliocommons/availability-status';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bindAll } from '@bibliocommons/utils-react';
import { SecondaryLink } from '@bibliocommons/base-links';
import { availabilityEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { AvailabilityDetailsContainer } from 'app/components/bibs/shared/AvailabilityDetails';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';

const { composeViewAvailabilityEvent } = availabilityEventComposer;

export default class AvailabilityDetailsLink extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      open: false
    };
  }

  handleOpen() {
    this.setState({ open: true });

    const metadataId = this.props.bib.get('id');
    const status = this.props.availability.get('status');
    sendAnalyticsEvents(
      composeViewAvailabilityEvent({
        status,
        metadataId
      })
    );
  }

  handleClose() {
    this.setState({ open: false });
  }

  renderContent() {
    const { bib, availability } = this.props;
    const format = bib.getIn(['briefInfo', 'format']);

    return (
      <span>
        <span aria-hidden="true">
          <FormattedMessage id="Availability.detailsLink" />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage
            id="Availability.ada_detailsLink"
            values={{
              title: bib.getIn(['briefInfo', 'title']),
              format: <FormattedMessage id={`FORMAT.${format.toLowerCase()}`} />,
              status: (
                <AvailabilityStatus
                  rollUpStatus={availability.get('statusType')}
                  status={availability.get('localisedStatus')}
                  availabilityLocationType={availability.get('availabilityLocationType')}
                />
              )
            }}
          />
        </ScreenReaderMessage>
      </span>
    );
  }

  render() {
    const { bib, linkTag, children } = this.props;
    const LinkTag = linkTag || SecondaryLink;
    const materialType = bib.getIn(['policy', 'materialType']);

    return materialType === 'PHYSICAL' ? (
      <div className="cp-availability-details-link">
        <LinkTag
          href="#availability-details-overlay"
          dataKey="availability-details-link"
          handleClick={this.handleOpen}
          preventDefault
        >
          {children || this.renderContent()}
        </LinkTag>

        <FullScreenOverlayContainer
          open={this.state.open}
          handleClose={this.handleClose}
          overlayKey="availability-details-full-screen-overlay"
          dataKey="availability-details-full-screen-overlay"
        >
          {this.state.open && <AvailabilityDetailsContainer metadataId={bib.get('id')} />}
        </FullScreenOverlayContainer>
      </div>
    ) : null;
  }
}

AvailabilityDetailsLink.propTypes = {
  bib: bibShape.isRequired,
  availability: availabilityShape.isRequired,
  children: childrenShape,
  linkTag: PropTypes.func
};
